// Statsig gate / experiment names used in this project.
// Add new entries here so the dashboard and code stay in sync,
// and so call sites never pass raw string literals.
export const IBX_SELF_PAY = 'ibx_self_pay';
export const EMPLOYER_CONTRIBUTION = 'employer_contribution';
export const PRESCRIPTION_SAVINGS_TILE = 'prescription_savings_tile';
